"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const propTypes = {
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    icon: _propTypes.default.string
  })).isRequired,
  currentStep: _propTypes.default.number
};
const defaultProps = {
  steps: [],
  currentStep: null
};
function Stepper(_ref) {
  let {
    steps,
    currentStep
  } = _ref;
  const arrSteps = (0, _react.useMemo)(() => steps === null || steps === void 0 ? void 0 : steps.map((step, index) => _objectSpread(_objectSpread({}, step), {}, {
    id: index + 1
  })), [steps]);
  return /*#__PURE__*/_react.default.createElement(Container, null, arrSteps === null || arrSteps === void 0 ? void 0 : arrSteps.map(_ref2 => {
    let {
      name,
      icon,
      id
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(Step, {
      didItGetToThisPosition: currentStep >= id
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: icon,
      size: 23
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      size: 11.5
    }, id, ". ", name)), (steps === null || steps === void 0 ? void 0 : steps.length) > id && /*#__PURE__*/_react.default.createElement(Line, {
      currentStep: currentStep,
      stepNumber: id
    }));
  }));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
const Step = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  justify-items: center;\n\n  i, p {\n    color: ", ";\n  }\n  \n"])), _ref3 => {
  let {
    theme,
    didItGetToThisPosition
  } = _ref3;
  return didItGetToThisPosition ? theme.colors.MAIN.PRIMARY : theme.colors.FONT.DESCRIPTION;
});
const Line = _styled.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 60px;\n  height: 2px;\n  background: ", "\n"])), _ref4 => {
  let {
    theme,
    currentStep,
    stepNumber
  } = _ref4;
  const {
    colors
  } = theme;
  if (currentStep > stepNumber) return colors.MAIN.PRIMARY;
  if (currentStep === stepNumber) return "linear-gradient(90deg, ".concat(colors.MAIN.PRIMARY, " 50%, ").concat(colors.NEUTRAL.SELECTED, " 50%)");
  return colors.NEUTRAL.SELECTED;
});
Stepper.propTypes = propTypes;
Stepper.defaultProps = defaultProps;
var _default = exports.default = Stepper;